/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The constant used for an empty value in the Customer List.
 * @export
 */
export const CUSTOMER_LIST_EMPTY_VALUE = `-`;
